import { BaseApiClient } from '../client'
import type { Seeding, CreateSeedingInput, UpdateSeedingStatusInput } from '../types'

export class SeedingsApi extends BaseApiClient {
  async list(
    creatorId: string,
    params?: { page?: number; limit?: number; status?: string }
  ): Promise<Seeding[]> {
    const query = new URLSearchParams()
    if (params?.page) query.append('page', params.page.toString())
    if (params?.limit) query.append('limit', params.limit.toString())
    if (params?.status) query.append('status', params.status)

    return this.request(
      `/api/admin/creators/${creatorId}/seedings${query.toString() ? `?${query}` : ''}`
    )
  }

  async getById(id: string): Promise<Seeding> {
    const response = await this.request<{ data: Seeding }>(`/api/admin/seedings/${id}`)
    return response.data
  }

  async create(data: CreateSeedingInput): Promise<Seeding> {
    const { creatorId, ...body } = data
    const response = await this.request<{ data: Seeding }>(
      `/api/admin/creators/${creatorId}/seedings`,
      {
        method: 'POST',
        body: JSON.stringify(body),
      }
    )
    return response.data
  }

  async updateStatus(id: string, data: UpdateSeedingStatusInput): Promise<Seeding> {
    const response = await this.request<{ data: Seeding }>(`/api/admin/seedings/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    })
    return response.data
  }

  async delete(creatorId: string, seedingId: string): Promise<void> {
    await this.request(`/api/admin/creators/${creatorId}/seedings/${seedingId}`, {
      method: 'DELETE',
    })
  }
}
